module.exports = __webpack_public_path__ + "static/media/topleft.469a0cbf.svg";